
<select [ngStyle]="styles" class="select" [(ngModel)]="value" (change)="updateValue($any($event.target).value)" [attr.disabled]="disabled ? '' : null">
  <option *ngFor="let t of options" [value]="t[keyField]">{{t[displayField]}}</option>
</select>

